import { Button } from "components/Button/Button";
import { Input, Select, TextArea } from "components/Form";
import useFullPageLoader from "hooks/useFullPageLoader";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import React, { useLayoutEffect, useState } from "react";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import {
  addProduct,
  getCategoryDropdownList,
} from "services/inventorymanagement";

export default function AddProduct() {
  const [data, setData] = useState({});
  const [errorField, setErrorField] = useState({});

  const [allCategories, setAllCategories] = useState([]);

  const navigate = useNavigate();
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();

  // ****************************** Fetch All Categories *****************************************
  const fetchAllCategories = async () => {
    showLoader();
    try {
      const res = await getCategoryDropdownList();
      hideLoader();
      if (res.code === 200) {
        setAllCategories(
          res.data.categories.rows.map(({ id, categoryname }) => {
            return { label: categoryname, value: id };
          }) || []
        );
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    hideLoader();
  };
  useLayoutEffect(() => {
    fetchAllCategories();
    // fetchAllRoles();
  }, []);

  //*********************Handel Validation********************************** */
  const handleValidation = () => {
    let errorField = {};
    let formIsValid = true;

    if (!data.category) {
      errorField["category"] = "Please Enter Category";
      formIsValid = false;
    }

    if (!data.productName) {
      errorField["productName"] = "Please Enter Product Name";
      formIsValid = false;
    }

    // if (!data.productCode) {
    //   errorField["productCode"] = "Please Enter Product Code";
    //   formIsValid = false;
    // }

    if (!data.itemCode) {
      errorField["itemCode"] = "Please Enter Item Code";
      formIsValid = false;
    }

    if (!data.costPrice) {
      errorField["costPrice"] = "Please Enter Cost Price";
      formIsValid = false;
    }

    if (!data.sellingPrice) {
      errorField["sellingPrice"] = "Please Enter Selling Price";
      formIsValid = false;
    }

    if (!data.quantity) {
      errorField["quantity"] = "Please Enter Quantity";
      formIsValid = false;
    }

    setErrorField(errorField);
    return formIsValid;
  };
  //*********************Submit Product Handler********************************** *//
  const submitProduct = async (e) => {
    e.preventDefault();
    if (handleValidation()) {
      setSubmitLoading(true);
      try {
        const res = await addProduct({
          producttitle: data.productName,
          productdescription: data.productDescription,
          categoryid: data.category,
        //   productcode: data.productCode,
          costprice: data.costPrice,
          sellingprice: data.sellingPrice,
          quantity: data.quantity,
          itemcode: data.itemCode,
        });
        if (res.code === 200) {
          toast.success(res.message);
          setSubmitLoading(false);
          navigate(-1);
        } else {
          toast.error(res.message);
          setSubmitLoading(false);
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || err.message);
        setSubmitLoading(false);
      }
    } else {
      toast.error("Please fill all the fields");
    }
  };

  return (
    <>
      <div className="">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="search_wrap">
              <div className="search_wrap"></div>
              <h4 className="Title">
                <Link to={-1}>
                  <i className="fa fa-arrow-left"></i>
                </Link>
                Add Product
              </h4>
            </div>
            <div className="row mt-1">
              <div className="col-12 col-sm-12 col-md-12 col-lg-11 col-xl-11 mx-auto">
                <form onSubmit={submitProduct}>
                  <div className="form-group row mt-1">
                    <div className="col-md-12 col-form-label order-1 d-flex flex-column justify-content-end">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="row">
                            <div className="col-sm-6  col-form-label">
                              <Select
                                name="category"
                                placeholder="Select Category"
                                onChange={(e) => {
                                  const { name, value } = e.target;
                                  setData({ ...data, [name]: value });
                                }}
                                value={data.category}
                                className={`form-control `}
                                label={"Category"}
                                error={errorField.category}
                                required
                              >
                                <option value="">Select Category</option>
                                {allCategories &&
                                  allCategories.map(({ label, value }) => {
                                    return (
                                      <option value={value} key={value}>
                                        {label}
                                      </option>
                                    );
                                  })}
                              </Select>
                            </div>
                            <div className="col-sm-6 col-form-label">
                              <Input
                                type="text"
                                name="productName"
                                value={data.productName}
                                onChange={(e) => {
                                  const { value, name } = e.target;
                                  setData({
                                    ...data,
                                    [name]: value,
                                  });
                                }}
                                placeholder="Enter Product Name"
                                className={`form-control `}
                                maxLength={50}
                                label="Product Name"
                                error={errorField.productName}
                                required
                              />
                            </div>
                            {/* <div className="col-sm-6 col-form-label">
                              <Input
                                type="text"
                                name="productCode"
                                value={data.productCode}
                                onChange={(e) => {
                                  const { value, name } = e.target;
                                  setData({
                                    ...data,
                                    [name]: value,
                                  });
                                }}
                                placeholder="Enter Product Code"
                                className={`form-control `}
                                maxLength={50}
                                label="Product Code"
                                error={errorField.productCode}
                                required
                              />
                            </div> */}
                            <div className="col-sm-6 col-form-label">
                              <Input
                                type="text"
                                name="itemCode"
                                value={data.itemCode}
                                onChange={(e) => {
                                  const { value, name } = e.target;
                                  setData({
                                    ...data,
                                    [name]: value,
                                  });
                                }}
                                placeholder="Enter Item Code"
                                className={`form-control `}
                                maxLength={50}
                                label="Item Code"
                                error={errorField.itemCode}
                                required
                              />
                            </div>
                            <div className="col-sm-6 col-form-label">
                              <Input
                                type="text"
                                name="costPrice"
                                value={data.costPrice}
                                onChange={(e) => {
                                  const { value, name } = e.target;
                                  setData({
                                    ...data,
                                    [name]: value.replace(/\D/g, ""),
                                  });
                                }}
                                placeholder="Enter Cost Price"
                                className={`form-control `}
                                maxLength={20}
                                label="Cost Price"
                                error={errorField.costPrice}
                                required
                              />
                            </div>
                            <div className="col-sm-6 col-form-label">
                              <Input
                                type="text"
                                name="sellingPrice"
                                value={data.sellingPrice}
                                onChange={(e) => {
                                  const { value, name } = e.target;
                                  setData({
                                    ...data,
                                    [name]: value.replace(/\D/g, ""),
                                  });
                                }}
                                placeholder="Enter Selling Price"
                                className={`form-control `}
                                maxLength={20}
                                label="Selling Price"
                                error={errorField.sellingPrice}
                                required
                              />
                            </div>

                            <div className="col-sm-6 col-form-label">
                              <Input
                                type="text"
                                name="quantity"
                                value={data.quantity}
                                onChange={(e) => {
                                  const { value, name } = e.target;
                                  setData({
                                    ...data,
                                    [name]: value.replace(/\D/g, ""),
                                  });
                                }}
                                placeholder="Enter Quantity"
                                className={`form-control `}
                                maxLength={20}
                                label="Quantity"
                                error={errorField.quantity}
                                required
                              />
                            </div>
                            <div className="col-sm-12 col-form-label">
                              <TextArea
                                type="text"
                                name="productDescription"
                                value={data.productDescription}
                                onChange={(e) => {
                                  const { value, name } = e.target;
                                  setData({ ...data, [name]: value });
                                }}
                                placeholder="Enter Product Description"
                                className={`form-control `}
                                label="Product Description"
                                rows={7}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="text-center mt-4">
                    <Button
                      to={-1}
                      // {...submitButtonElement}
                      style={{ marginRight: "5px" }}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      // {...submitButtonElement}
                    >
                      Add Product
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
